import type { TransactionReceipt } from 'viem';

export const assertSuccessfulReceipt = (receipt: TransactionReceipt): TransactionReceipt => {
  if (receipt.status !== 'success') throw new Error('transaction-reverted');
  return receipt;
};
